import React, { Component } from 'react'
import ToggleSection from 'components/settings/ChatWidget/components/Advanced/components/ToggleSection'
import EditConfiguration from './EditConfiguration'

class AutoCloseConfiguration extends Component {
  handleIsEnabledToggled = event => {
    this.props.setIsEnabled(event.target.checked)
  }

  render() {
    const {
      isEnabled,
      timeoutValue,
      timeoutUnit,
      hasUnsavedChanges,
      setTimeoutUnit,
      setTimeoutValue,
      saveChanges,
      discardUnsavedChanged,
      minTimeoutValue,
      maxTimeoutValue,
      exceedsLimitText,
      filters,
      setFilters,
    } = this.props

    return (
      <ToggleSection
        title="Auto-close conversations after a period of inactivity"
        description="Automatically close conversations where participants are unresponsive."
        isChecked={isEnabled}
        className="advanced-settings-toggle"
        onToggled={this.handleIsEnabledToggled}
      >
        {isEnabled &&
          <EditConfiguration
            timeoutValue={timeoutValue}
            timeoutUnit={timeoutUnit}
            hasUnsavedChanges={hasUnsavedChanges}
            setTimeoutUnit={setTimeoutUnit}
            setTimeoutValue={setTimeoutValue}
            saveChanges={saveChanges}
            discardUnsavedChanged={discardUnsavedChanged}
            minTimeoutValue={minTimeoutValue}
            maxTimeoutValue={maxTimeoutValue}
            exceedsLimitText={exceedsLimitText}
            filters={filters}
            setFilters={setFilters}/>
        }
      </ToggleSection>
    )
  }
}

export default AutoCloseConfiguration



// WEBPACK FOOTER //
// ./src/scripts/components/settings/advancedConversationSettings/AutoCloseConfiguration/component.js